import React from 'react';
import GrandPage from '../../Components/GrandPage/GrandPage';
import Image from '../../Components/ImageComponent/Image';
import ImageRightPoints from 'components/TitleSections/Components/ImageComponent/ImageRightPont';
import styles from './BannerHalfWidth.module.scss';
import MenuTiles from '../../../MenuTiles/MenuTiles';
import TitleComponent from '../../Components/TitleComponent/TItleComponent';

const BannerHalfWidth = ({ api }) => {
  return (
    <section id={api?.id} className={`allImage ${styles.bannerHalfWidth}`}>
      <div className={styles.topContainer}>
        <div className={styles.contentContainer}>
          <TitleComponent
            type="bannerHalfWidth f-300"
            properties={api.attributes}
            animationData={{ animation: 'fade-right', animationDuration: '1000', animationEasing: 'easy-in-out' }}
          />
        </div>
        <div
          className={
            api?.attributes?.image?.imagePointsYellow?.length || api?.attributes?.image?.imagePointsCoordinates?.length ? styles.scrollImage : ''
          }
        >
          <div
            className={`hide ${
              api?.attributes?.image?.imagePointsYellow?.length || api?.attributes?.image?.imagePointsCoordinates?.length ? styles.handButton : ''
            }`}
          ></div>
          <div className={`${styles.imageContainer} ${styles.imageWrapperWithButton}`}>
            {/* <Image
            type="leftSide"
            properties={api.attributes}
            animationData={{ animation: 'fade-up', animationDuration: '1000', animationEasing: 'easy-in-out' }}
          /> */}
            <ImageRightPoints properties={api.attributes} />
          </div>
        </div>
      </div>
      <div className={styles.downContainer}>
        <GrandPage
          type="HalfBoxDesc"
          properties={api.attributes}
          blockID={api.id}
          animationData={{ animation: 'fade-up', animationDuration: '500', animationEasing: 'easy-in-out' }}
        />
      </div>
    </section>
  );
};

export default BannerHalfWidth;
